import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form as FormDHX } from "dhx-suite";
import "../../../dhtmlx/codebase/suite.css";

class Form extends Component {

	componentDidMount() {
		const { css, rows, padding, title, width, align, toggleInputs, toggleValid} = this.props;
		this.form = new FormDHX(this.el, {
			css,
			padding,
			rows,
			title,
			width,
			align,
		});
		this.form.events.on("change",()=>{
			let valid = this.form.validate();
			toggleInputs(this.form.getValue());
			toggleValid(valid);
			});
			
		this.form.events.on("keydown",(event, name, id)=>{
			if(event.key !== " "){
				let valid = this.form.validate();
				toggleValid(valid);
			}
		});
	}
	componentDidUpdate(){
		const { loading,rows } = this.props;
		if(loading){
			rows.forEach((element, index)=>{
				this.form.getItem(element.id).disable();
			});
		}else{
			//va dentro de un cathc para que no falle antes de cargar los rows
			try {
				rows.forEach((element, index)=>{
					this.form.getItem(element.id).enable();
				});
			} catch (error) {
				return true;
			}
		}
	}
	componentWillUnmount() {
		this.form && this.form.destructor();
	}
	render() {
		return <form style={{ padding:'16px 0' }} ref={el => (this.el = el)}></form>;
	}
}
const Formulario = (props) => {
	
		return (
			<Form
				rows={props.rows}
				toggleInputs =  {props.toggleInputs}
				toggleValid =  {props.toggleValid}
				padding = {props.padding}
        width = {props.width}
				loading = {props.loading}
				css={props.css}
			/>
		);
}
Form.propTypes = {
	css: PropTypes.string,
	width: PropTypes.string || PropTypes.number,
	height: PropTypes.string || PropTypes.number,
	rows: PropTypes.array,
	cols: PropTypes.array,
	title: PropTypes.string,
	align: PropTypes.oneOf(["start", "center", "end", "between", "around", "evenly"]),
	padding: PropTypes.number,
	disabled: PropTypes.bool,
};

export  {Formulario};